export default {
  'Low-income': 'rgb(207, 223, 255)',
  'Upper-middle-income': 'rgb(208, 240, 253)',
  'Lower-middle-income': 'rgb(194, 245, 233)',
  'High-income': 'rgb(209, 247, 196)',
}
